/**
 * @flow
 * Created by neo on 12.07.17.
 */

import * as React from 'react';
import { Router, Route, hashHistory, IndexRoute } from 'react-router';
import { observer } from 'mobx-react';

import Main from '../Layout/Main';
import NoMatch from '../NoMatch';
import AnalysisIndexScreen from '../Views/Analysis/index';
import AnalysisViewScreen from '../Views/Analysis/View/index';

@observer
export default class Navigation extends React.Component<any, any> {
  render() {
    return (
      <Router history={hashHistory}>
        <Route path="/" component={Main}>
          <IndexRoute component={AnalysisIndexScreen} />
          <Route path="analysis">
            <IndexRoute component={AnalysisIndexScreen} />
            <Route path=":id" component={AnalysisViewScreen} />
          </Route>
        </Route>
        <Route path="*" component={NoMatch} />
      </Router>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/Navigation/index.js